// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__37DZj","modalForm":"UpgradeEpcsModal_modalForm__1Qq_F","modalFooter":"UpgradeEpcsModal_modalFooter__3DPpf"};